import { render } from "./FortigateProfileDetails.vue?vue&type=template&id=43840f28"
import script from "./FortigateProfileDetails.vue?vue&type=script&lang=js"
export * from "./FortigateProfileDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__